import { IGenericObject, GenericObject } from "../common";
import { BaseModel } from "../base-model";
import { IKeuringsPlatformInfoModel, KeuringsPlatformInfoModel } from "./property-keuring-platform.model";

//For response 
export interface ISmoovedInfoResponseModel {
  PropertyType?: string;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  PropertyCountryId?: number;
  ConstructionYear?: string;
  PropertyBoxNumber?: string;
  Bedrooms?: number;
  LivingRooms?: number;
  Bathrooms?: number;
  Attics?: number;
  ParkingSpotsInGarage?: number;
  IsElectricity?: boolean;
  ElectricitySimpleMeterNumber?: number;
  ElectricityDoubleMeterNumber?: number;
  ElectricityDoubleNightMeterReading?: number;
  ElectricityNightOnlyMeterNumber?: number;
  IsGas?: boolean;
  GasMeterReading?: number;
  Genders?: IGenericObject[];
  Constructions?: IGenericObject[];
  Construction_DetachedSizes?: IGenericObject[];
  Construction_HalfOpenSizes?: IGenericObject[];
  Construction_ClosedSizes?: IGenericObject[];
  Construction_ApartmentSizes?: IGenericObject[];
  ConstructionYears?: IGenericObject[];
  MeterTypes?: IGenericObject[];
  TransfereeTypes?: IGenericObject[];
  LeaverTypes?: IGenericObject[];
  ContactInfos?: IKeuringsPlatformInfoModel[];
  LeavingCustomers?: ISmoovedLeavingCustomerModel[];
  Nationalities?: IGenericObject[];
}

export class SmoovedInfoResponseModel extends BaseModel<ISmoovedInfoResponseModel> implements ISmoovedInfoResponseModel {
  PropertyType?: string;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  PropertyCountryId?: number;
  PropertyBoxNumber?: string;
  ConstructionYear?: string;
  Bedrooms?: number;
  LivingRooms?: number;
  Bathrooms?: number;
  Attics?: number;
  ParkingSpotsInGarage?: number;
  IsElectricity?: boolean;
  ElectricitySimpleMeterNumber?: number;
  ElectricityDoubleMeterNumber?: number;
  ElectricityDoubleNightMeterReading?: number;
  ElectricityNightOnlyMeterNumber?: number;
  IsGas?: boolean;
  GasMeterReading?: number;
  Genders?: IGenericObject[];
  Constructions?: IGenericObject[];
  Construction_DetachedSizes?: IGenericObject[];
  Construction_HalfOpenSizes?: IGenericObject[];
  Construction_ClosedSizes?: IGenericObject[];
  Construction_ApartmentSizes?: IGenericObject[];
  ConstructionYears?: IGenericObject[];
  MeterTypes?: IGenericObject[];
  TransfereeTypes?: IGenericObject[];
  LeaverTypes?: IGenericObject[];
  ContactInfos?: IKeuringsPlatformInfoModel[];
  LeavingCustomers?: ISmoovedLeavingCustomerModel[];
  Nationalities?: IGenericObject[];
  constructor(option?: ISmoovedInfoResponseModel) {
    super(option);
    this.PropertyAddress = option.PropertyAddress;
    this.PropertyHouseNumber = option.PropertyHouseNumber;
    this.PropertyPostCode = option.PropertyPostCode;
    this.PropertyCityName = option.PropertyCityName;
    this.PropertyCountryId = option.PropertyCountryId;
    this.PropertyBoxNumber = option.PropertyBoxNumber;
    this.ConstructionYear = option.ConstructionYear;
    this.Bedrooms = option.Bedrooms || 0;
    this.LivingRooms = option.LivingRooms || 0;
    this.Bathrooms = option.Bathrooms || 0;
    this.Attics = option.Attics || 0;
    this.ParkingSpotsInGarage = option.ParkingSpotsInGarage || 0;
    this.IsElectricity = option.IsElectricity || false;
    this.ElectricitySimpleMeterNumber = option.ElectricitySimpleMeterNumber || 0;
    this.ElectricityDoubleNightMeterReading = option.ElectricityDoubleNightMeterReading || 0;
    this.ElectricityNightOnlyMeterNumber = option.ElectricityNightOnlyMeterNumber || 0;
    this.Genders = option.Genders || [];
    this.Constructions = option.Constructions || [];
    this.Construction_DetachedSizes = option.Construction_DetachedSizes || [];
    this.Construction_HalfOpenSizes = option.Construction_HalfOpenSizes || [];
    this.Construction_ClosedSizes = option.Construction_ClosedSizes || [];
    this.Construction_ApartmentSizes = option.Construction_ApartmentSizes || [];
    this.ConstructionYears = option.ConstructionYears || [];
    this.MeterTypes = option.MeterTypes || [];
    this.TransfereeTypes = option.TransfereeTypes || [];
    this.LeaverTypes = option.LeaverTypes || [];
    this.ContactInfos = option.ContactInfos || [];
    this.LeavingCustomers = option.LeavingCustomers || [];
    this.Nationalities = option.Nationalities || [];
  }
}


//For request or send data
export interface ISmoovedRequestModel {
  PropertyId?: number;
  PropertySiteId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  PropertyPurposeId?: number;
  PropertyCountryName?: string;
  PropertyCountryId?: number;
  CategoryType?: IGenericObject;
  Transaction?: IGenericObject;
  PropertyCountry?: IGenericObject;
  PrimaryContact?: IKeuringsPlatformInfoModel;
  LeavingCustomer?: ISmoovedLeavingCustomerModel;
  Connection?: ISmoovedConnectionModel;
  PropertyBoxNumber?: string;
  PropertyType?: string;
  PropertySize?: string;
  PropertyFloor?: number;
  ConstructionYear?: string;
  Bedrooms?: number;
  LivingRooms?: number;
  Kitchens?: number;
  Bathrooms?: number;
  Verandas?: number;
  Attics?: number;
  Basements?: number;
  ParkingSpotsInGarage?: number;
  OtherRoomsLargerThanFourSquaredMeter?: number;
  OuthouseLargerThanTenSquaredMeter?: number;
  RenterType?: string;
  LeavingType?: string;
}

export class SmoovedRequestModel extends BaseModel<ISmoovedRequestModel> implements ISmoovedRequestModel {
  PropertyId?: number;
  PropertySiteId?: number;
  PropertyAddress?: string;
  PropertyHouseNumber?: string;
  PropertyPostCode?: string;
  PropertyCityName?: string;
  PropertyPurposeId?: number;
  PropertyCountryName?: string;
  PropertyCountryId?: number;
  CategoryType?: IGenericObject;
  Transaction?: IGenericObject;
  PropertyCountry?: IGenericObject;
  PrimaryContact?: IKeuringsPlatformInfoModel;
  LeavingCustomer?: ISmoovedLeavingCustomerModel;
  Connection?: ISmoovedConnectionModel;
  PropertyBoxNumber?: string;
  PropertyType?: string;
  PropertySize?: string;
  PropertyFloor?: number;
  ConstructionYear?: string;
  Bedrooms?: number;
  LivingRooms?: number;
  Kitchens?: number;
  Bathrooms?: number;
  Verandas?: number;
  Attics?: number;
  Basements?: number;
  ParkingSpotsInGarage?: number;
  OtherRoomsLargerThanFourSquaredMeter?: number;
  OuthouseLargerThanTenSquaredMeter?: number;
  RenterType?: string;
  LeavingType?: string;
  constructor(option?: ISmoovedRequestModel) {
    super(option);
    this.PropertyId = option.PropertyId || null;
    this.PropertyAddress = option.PropertyAddress || null;
    this.PropertyHouseNumber = option.PropertyHouseNumber || null;
    this.PropertyPostCode = option.PropertyPostCode || null;
    this.PropertyCityName = option.PropertyPostCode || null;
    this.PropertyPurposeId = option.PropertyPurposeId || null;
    this.PropertyCountryId = option.PropertyCountryId || null;
    this.PropertySiteId = option.PropertySiteId || null;
    this.PropertyCountryName = option.PropertyCountryName || null;
    this.CategoryType = option.CategoryType || new GenericObject();
    this.Transaction = option.Transaction || new GenericObject();
    this.PropertyCountry = option.PropertyCountry || new GenericObject();
    this.PrimaryContact = option.PrimaryContact || new KeuringsPlatformInfoModel({});
    this.LeavingCustomer = option.LeavingCustomer || new SmoovedLeavingCustomerModel({});
    this.Connection = option.Connection || new SmoovedConnectionModel({});
    this.PropertyBoxNumber = option.PropertyBoxNumber || null;
    this.PropertyType = option.PropertyType || null;
    this.PropertySize = option.PropertySize || null;
    this.PropertyFloor = option.PropertyFloor || null;
    this.ConstructionYear = option.ConstructionYear || null;
    this.Bedrooms = option.Bedrooms || null;
    this.LivingRooms = option.LivingRooms || null;
    this.Kitchens = option.Kitchens || null;
    this.Bathrooms = option.Bathrooms || null;
    this.Verandas = option.Verandas || null;
    this.Attics = option.Attics || null;
    this.Basements = option.Basements || null;
    this.ParkingSpotsInGarage = option.ParkingSpotsInGarage || null;
    this.OtherRoomsLargerThanFourSquaredMeter = option.OtherRoomsLargerThanFourSquaredMeter || null;
    this.OuthouseLargerThanTenSquaredMeter = option.OuthouseLargerThanTenSquaredMeter || null;
    this.RenterType = option.RenterType || null;
    this.LeavingType = option.LeavingType || null;
  }
}

export interface ISmoovedConnectionModel {
  IsElectricity?: boolean;
  NightOnly?: boolean;
  SolarPanels?: boolean;
  ElectricHeating?: boolean;
  ElectricitySimpleMeterNumber?: number;
  ElectricityDoubleMeterNumber?: number;
  ElectricityDoubleNightMeterReading?: number;
  ElectricityNightOnlyMeterNumber?: number;
  MeterType?: string;
  EanCodeElectricitry?: string;
  IsGas?: boolean;
  GasMeterReading?: number;
  EanCodeGas?: string;
}

export class SmoovedConnectionModel extends BaseModel<ISmoovedConnectionModel> implements ISmoovedConnectionModel { 
  IsElectricity?: boolean;
  NightOnly?: boolean;
  SolarPanels?: boolean;
  ElectricHeating?: boolean;
  ElectricitySimpleMeterNumber?: number;
  ElectricityDoubleMeterNumber?: number;
  ElectricityDoubleNightMeterReading?: number;
  ElectricityNightOnlyMeterNumber?: number;
  MeterType?: string;
  EanCodeElectricitry?: string;
  IsGas?: boolean;
  GasMeterReading?: number;
  EanCodeGas?: string;
  constructor(option?: ISmoovedConnectionModel) {
    super(option);
    this.IsElectricity = option.IsElectricity || false;
    this.NightOnly = option.NightOnly || false;
    this.SolarPanels = option.SolarPanels || false;
    this.ElectricHeating = option.ElectricHeating || false;
    this.ElectricitySimpleMeterNumber = option.ElectricitySimpleMeterNumber || null;
    this.ElectricityDoubleMeterNumber = option.ElectricityDoubleMeterNumber || null;
    this.ElectricityDoubleNightMeterReading = option.ElectricityDoubleNightMeterReading || null;
    this.ElectricityNightOnlyMeterNumber = option.ElectricityNightOnlyMeterNumber || null;
    this.MeterType = option.MeterType || null;
    this.EanCodeElectricitry = option.EanCodeElectricitry || null;
    this.IsGas = option.IsGas || false;
    this.GasMeterReading = option.GasMeterReading || null;
    this.EanCodeGas = option.EanCodeGas || null;
  }
}

export interface SMPhones {
  additionalProp1: string,
  additionalProp2: string,
  additionalProp3: string
}

export interface ISmoovedLeavingCustomerModel {
  Id?: string,
  TypeId?: number,
  FirstName?: string,
  Name?: string,
  Reference?: string,
  CompanyName?: string,
  VATNumber?: string,
  Address?: string,
  Address2?: string,
  HouseNumber?: string,
  BoxNumber?: string,
  PostCode?: string,
  CityName?: string,
  LanguageId?: number,
  CountryId?: number,
  Email?: string,
  Email2?: string,
  Email3?: string,
  PhoneNumber?: string,
  PhoneNumber2?: string,
  PhoneNumber3?: string,
  IsSelected?: boolean,
  Description?: string,
  VAT?: string,
  IsCompany?: boolean,
  NationalityId?: number,
  IDCardNumber?: string,
  Birthday?: string,
  Birthplace?: string,
  Phones?: SMPhones,
  Emails?: Array<string>,
  CountryName?: string,
  RegionName?: string,
  NationalityName?: string,
  AccountNumber?: string,
  NationalRegister?: string,
  SmoovedGender?: string
}

export class SmoovedLeavingCustomerModel extends BaseModel<ISmoovedLeavingCustomerModel> implements ISmoovedLeavingCustomerModel {
  Id?: string;
  TypeId?: number;
  FirstName?: string;
  Name?: string;
  Reference?: string;
  CompanyName?: string;
  VATNumber?: string;
  Address?: string;
  Address2?: string;
  HouseNumber?: string;
  BoxNumber?: string;
  PostCode?: string;
  CityName?: string;
  LanguageId?: number;
  CountryId?: number;
  Email?: string;
  Email2?: string;
  Email3?: string;
  PhoneNumber?: string;
  PhoneNumber2?: string;
  PhoneNumber3?: string;
  IsSelected?: boolean;
  Description?: string;
  VAT?: string;
  IsCompany?: boolean;
  NationalityId?: number;
  IDCardNumber?: string;
  Birthday?: string;
  Birthplace?: string;
  Phones?: SMPhones;
  Emails?: Array<string>;
  CountryName?: string;
  RegionName?: string;
  NationalityName?: string;
  AccountNumber?: string;
  NationalRegister?: string;
  SmoovedGender?: string;

  constructor(option?: ISmoovedLeavingCustomerModel) {
    super(option);
    this.Id = option.Id || null;
    this.TypeId = option.TypeId || 0;
    this.FirstName = option.FirstName || null;
    this.Name = option.Name || null;
    this.Reference = option.Reference || null;
    this.CompanyName = option.CompanyName || null;
    this.VATNumber = option.VATNumber || null;
    this.Address = option.Address || null;
    this.Address2 = option.Address2 || null;
    this.HouseNumber = option.HouseNumber || null;
    this.BoxNumber = option.BoxNumber || null;
    this.PostCode = option.PostCode || null;
    this.CityName = option.CityName || null;
    this.LanguageId = option.LanguageId || 0;
    this.CountryId = option.CountryId || 0;
    this.Email = option.Email || null;
    this.Email2 = option.Email2 || null;
    this.Email3 = option.Email3 || null;
    this.PhoneNumber = option.PhoneNumber || null;
    this.PhoneNumber2 = option.PhoneNumber2 || null;
    this.PhoneNumber3 = option.PhoneNumber3 || null;
    this.IsSelected = option.IsSelected || false;
    this.Description = option.Description || null;
    this.VAT = option.VAT || null;
    this.IsCompany = option.IsCompany || false;
    this.NationalityId = option.NationalityId || 0;
    this.IDCardNumber = option.IDCardNumber || null;
    this.Birthday = option.Birthday || null;
    this.Birthplace = option.Birthplace || null;
    this.Phones = option.Phones || null;
    this.Emails = option.Emails || [];
    this.CountryName = option.CountryName || null;
    this.RegionName = option.RegionName || null;
    this.NationalityName = option.NationalityName || null;
    this.AccountNumber = option.AccountNumber || null;
    this.NationalRegister = option.NationalRegister || null;
    this.SmoovedGender = option.SmoovedGender || null;
  }
}